import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "medical-record-container"
};
const _hoisted_3 = {
  class: "container-left"
};
const _hoisted_4 = {
  class: "upload-recording-box"
};
const _hoisted_5 = {
  class: "disease-name-input-box"
};
const _hoisted_6 = {
  class: "disease-name-input-box"
};
const _hoisted_7 = {
  class: "upload-recording-btn"
};
const _hoisted_8 = {
  class: "medical-record-list"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "delect-icon-box"
};
const _hoisted_11 = {
  class: "left"
};
const _hoisted_12 = {
  key: 0,
  class: "edit-patient-name"
};
const _hoisted_13 = {
  key: 1,
  class: "patient-name"
};
const _hoisted_14 = {
  class: "name-text"
};
const _hoisted_15 = {
  class: "created-time-box"
};
const _hoisted_16 = {
  class: "created-time"
};
const _hoisted_17 = {
  class: "recording-time"
};
const _hoisted_18 = {
  key: 2,
  class: "edit-disease-name"
};
const _hoisted_19 = {
  key: 3,
  class: "disease-name"
};
const _hoisted_20 = {
  class: "name-text"
};
const _hoisted_21 = {
  class: "right"
};
const _hoisted_22 = {
  key: 0,
  class: "status-text wait"
};
const _hoisted_23 = {
  key: 1,
  class: "status-text uploading"
};
const _hoisted_24 = {
  key: 2,
  class: "status-text analyzing-in-progress"
};
const _hoisted_25 = {
  key: 3,
  class: "status-text complete"
};
const _hoisted_26 = {
  key: 4,
  class: "status-text generation-completed"
};
const _hoisted_27 = {
  key: 5,
  class: "status-text fail"
};
const _hoisted_28 = {
  key: 0,
  class: "container-right"
};
const _hoisted_29 = {
  class: "title"
};
const _hoisted_30 = {
  class: "left"
};
const _hoisted_31 = {
  class: "patient-name"
};
const _hoisted_32 = {
  key: 0,
  class: "el-select-box"
};
const _hoisted_33 = {
  class: "select-option-box"
};
const _hoisted_34 = {
  style: {
    "float": "left"
  }
};
const _hoisted_35 = {
  style: {
    "float": "right",
    "margin": "4px 0 0 8px"
  }
};
const _hoisted_36 = {
  class: "right"
};
const _hoisted_37 = {
  class: "gtp-record"
};
const _hoisted_38 = {
  class: "add-result"
};
const _hoisted_39 = {
  key: 0,
  class: "patient-information-item"
};
const _hoisted_40 = {
  class: "textarea-box"
};
const _hoisted_41 = {
  class: "copy-btn-box"
};
const _hoisted_42 = {
  class: "left"
};
const _hoisted_43 = {
  class: "right"
};
const _hoisted_44 = {
  class: "title"
};
const _hoisted_45 = {
  class: "textarea-box"
};
const _hoisted_46 = {
  class: "copy-btn-box"
};
const _hoisted_47 = {
  class: "right"
};
const _hoisted_48 = {
  key: 2,
  class: "empty-box"
};
const _hoisted_49 = {
  class: "empty-text"
};
const _hoisted_50 = {
  class: "empty-btn"
};
const _hoisted_51 = {
  class: "ai-translate-list-box"
};
const _hoisted_52 = {
  class: "ai-translate-list"
};
const _hoisted_53 = {
  class: "translate-content"
};
const _hoisted_54 = {
  class: "ai-platform-list"
};
const _hoisted_55 = {
  class: "ai-platform-item"
};
const _hoisted_56 = {
  class: "dialog-footer"
};
const _hoisted_57 = {
  style: {
    "white-space": "pre-wrap"
  }
};
import { Edit, CloseBold, Close } from '@element-plus/icons-vue';
import { reactive, ref, onMounted, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ltyAsrUploadCreate, ltyAsruploadAf, ltyAsrAsrList, ltyAsrAsrResultList, ltyAsrAsrRecordList, ltyAsrAsrResult, ltyAsrAsrUpdateInfo, ltyAsrAsrGetRecordByAsrid, ltyAsrAsrCreateResultInfo, ltyAsrAsrDeleteFromAsrInfoByAsrId, ltyAsrAsrDeleteFromAsrResultByResultId } from '@/api/index';
import { ElMessage, radioButtonProps } from 'element-plus';
import dayjs from 'dayjs';
import clipboard3 from 'vue-clipboard3';
import { storeToRefs } from 'pinia';
import { homePage } from '../store/index';
import { OptionProps } from 'element-plus/es/components/select-v2/src/defaults';

import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message-box/style/css';
export default {
  __name: 'HomeView',
  setup(__props) {
    const {
      toClipboard
    } = clipboard3();
    const homePageStore = homePage();
    const router = useRouter();
    const route = useRoute();
    const userId = ref(null);
    const token = ref(null);
    const pageNumber = ref(1); // 语音列表第几页
    const pageSize = ref(20); // 语音列表每页数据
    const pageTotal = ref(0); // 数据总数量
    const dialogVisible = ref(false);
    const asrRecordId = ref(null); // 录音翻译id
    const asrPlatformId = ref(null); // 录音翻译平台ID
    const chatPlatformId = ref(0); // chat平台id   0:阿里-通义千问 2:百度-文心一言
    const currentlySelectedSoundRecord = ref(null); // 当前选中的录音文件信息
    const currentselectedAiText = ref(null); // 当前选中的AI生成的文本信息
    const aiTranslateList = ref(null);
    const medicalRecordList = ref(); // 录音文件列表
    const recordText = ref(null);
    const selectValue = ref(null);
    const selectOptions = ref([]);
    const createResult = ref(null); // 创建完成模板后 聊天界面通过router传回的参数
    const isLoopCallInterface = ref(false); // 是否需要轮询调用列表接口刷新列表状态
    const patientName = ref(''); // 表单中的患者名称
    const diseaseName = ref(''); // 表单中的患者病名
    const editPatientNameInputValue = ref(''); // 修改录音患者姓名
    const editPatientNameInputRef = ref(null); // 修改录音患者姓名 存储DOM元素的引用

    const editDiseaseNameInputValue = ref(''); // 修改录音患者病因
    const editDiseaseNameInputRef = ref(null); // 修改录音患者病因 存储DOM元素的引用

    const uploadfileLoading = ref(false);
    const isShowDrawer = ref(false); // 是否显示抽屉
    const drawerContent = ref(''); // 抽屉展示的文本内容
    const medicalRecordContent = ref([]); // 病历模板

    // 生成
    const generateHandle = item => {
      // asrRecordId // 录音翻译ID
      // asrPlatformId  录音翻译平台ID
      // chatPlatformId chat平台id   0:阿里-通义千问 2:百度-文心一言
      // currentlySelectedSoundRecord 当前选中的录音文件信息

      // 如果有拿到翻译信息-先创建任务再去聊天界面
      if (homePageStore.addResultParams) {
        ltyAsrAsrCreateResultInfo(homePageStore.addResultParams).then(res => {
          let params = {
            asrRecordId: asrRecordId.value,
            asrPlatformId: asrPlatformId.value,
            chatPlatformId: chatPlatformId.value,
            asrId: currentlySelectedSoundRecord.value.id,
            patientName: currentlySelectedSoundRecord.value.name,
            // 患者姓名
            diseaseName: currentlySelectedSoundRecord.value.title,
            // 疾病名称
            currentselectedAiText: currentselectedAiText.value
          };
          if (res.data.title) {
            params.title = res.data.title;
          }
          homePageStore.setMedicalRecordInformation(params);
          router.push({
            path: '/dialogue',
            query: {}
          });
        });
      }
    };

    // 新增结果
    const addResultsHandle = () => {
      // dialogVisible.value = true
      // let params = {
      //   userId: userId.value,
      //   token: token.value,
      //   asrId: currentlySelectedSoundRecord.value.id
      // }
      // 根据录音id获取翻译结果列表（因为现在只有一个翻译结果先不调用这个接口了）
      // ltyAsrAsrRecordList(params).then((res) => {
      //   if (res.data && res.data.length) {
      //     res.data.filter((item, index) => {
      //       if (index == 0) {
      //         asrRecordId.value = item.id // 录音翻译ID
      //         asrPlatformId.value = item.asrPlatformId // 录音翻译平台ID
      //         if (item.result) {
      //           currentselectedAiText.value = item.result
      //         }
      //       }
      //       if (item.result) {
      //         item.result = JSON.parse(item.result)
      //       }
      //     })
      //   }
      //   // 赋值
      //   aiTranslateList.value = res.data
      //   generateHandle()
      // })

      generateHandle();
    };

    // radio Change事件
    const changeRadio = value => {
      aiTranslateList.value.filter(item => {
        asrRecordId.value = item.id; // 录音翻译ID
        asrPlatformId.value = item.asrPlatformId; // 录音翻译平台ID
        if (item.id == value) {
          currentselectedAiText.value = JSON.stringify(item.result);
        }
      });
    };

    // gtp记录
    const gtpRecordHandle = () => {
      if (!selectValue.value) {
        ElMessage({
          showClose: true,
          message: '录音没有记录先新增一个看看吧~',
          type: 'warning'
        });
        return;
      }
      let chatKey = null;
      let params = {};
      selectOptions.value.filter(item => {
        if (item.id == selectValue.value) {
          chatKey = item.chatKey;
          // 根据选中的任务记录配置对话数据
          params = {
            asrRecordId: item.asrRecordId,
            asrPlatformId: item.asrPlatformId,
            chatPlatformId: item.chatPlatformId,
            asrId: item.asrId,
            chatKey: item.chatKey,
            currentselectedAiText: '',
            title: item.title,
            patientName: currentlySelectedSoundRecord.value.name,
            // 患者姓名
            diseaseName: currentlySelectedSoundRecord.value.title // 疾病名称
          };
        }
      });
      homePageStore.setChatkey(chatKey);
      homePageStore.setMedicalRecordInformation(params);
      // router.push({
      //   path: '/dialogue'
      // })
      setTimeout(() => {
        let href = router.resolve({
          name: 'dialogue',
          path: '/asr/dialogue',
          query: {
            name: 111
          }
        });
        window.open(href.href, '_blank');
      }, 500);
    };

    // 选择录音文件
    const selectedMedicalRecord = (item, index) => {
      console.log('选择录音文件', item);
      console.log('medicalRecordList', medicalRecordList);
      if (item.taskStatus != 3) {
        ElMessage({
          showClose: true,
          message: '录音文件还未识别完成，请稍等~',
          type: 'warning'
        });
        return;
      }
      medicalRecordList.value.forEach((item, i) => {
        item.isActive = false;
        if (index == i) {
          item.isActive = true;
          currentlySelectedSoundRecord.value = item;
          // createResult.value = null;
          recordText.value = null;
        }
      });
      homePageStore.setChatkey(null);
      // 通过录音id获取翻译结果
      getLtyAsrAsrGetRecordByAsrid(item);
    };

    // 通过录音id获取翻译结果
    const getLtyAsrAsrGetRecordByAsrid = item => {
      // asrRecordId // 录音翻译ID
      // asrPlatformId  录音翻译平台ID
      let params = {
        userId: userId.value,
        token: token.value,
        asrId: item.id
      };
      ltyAsrAsrGetRecordByAsrid(params).then(res => {
        if (res.success && res.data && res.data.result) {
          let text = '';
          JSON.parse(res.data.result).filter(resultItem => {
            text += resultItem.text + '\n';
          });
          recordText.value = text;
          currentselectedAiText.value = res.data.result;
          asrRecordId.value = res.data.id; // 录音翻译ID
          asrPlatformId.value = res.data.asrPlatformId; // 翻译平台id

          let params = {
            userId: userId.value,
            token: token.value,
            asrPlatformId: res.data.asrPlatformId,
            // 翻译平台id
            asrRecordId: res.data.id,
            // 翻译结果ID
            chatPlatformId: 0 // 聊天平台id,默认阿里
          };
          // 设置用户点击新增结果时候需要的参数
          homePageStore.setAddResultParams(params);
          // 获取选中任务的任务记录列表（有翻译结果才去获取）
          getLtyAsrAsrResultList(item);
        } else {
          recordText.value = null;
        }
      }).catch(err => {
        recordText.value = null;
      });
    };

    // 删除语音记录
    const deleteVoiceHandle = (item, index) => {
      let params = {
        userId: userId.value,
        token: token.value,
        asrId: item.id
      };
      ElMessageBox.confirm('您确认要删除该病历吗?', '删除病历', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        ltyAsrAsrDeleteFromAsrInfoByAsrId(params).then(res => {
          if (res.success) {
            ElMessage({
              type: 'success',
              message: '删除成功'
            });
            // 重新获取病历列表（刷新一下）
            GetltyAsrAsrList();
          } else {
            ElMessage({
              type: 'error',
              message: res.error || '删除失败'
            });
          }
        }).catch(err => {
          ElMessage({
            type: 'error',
            message: err || '删除失败'
          });
        });
      }).catch(() => {});
    };

    // 删除任务模板记录
    const deleteTaskRecord = item => {
      let params = {
        userId: userId.value,
        token: token.value,
        resultId: item.id
      };
      ElMessageBox.confirm('您确认要删除该病历模板记录吗?', '删除病历模板记录', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        ltyAsrAsrDeleteFromAsrResultByResultId(params).then(res => {
          if (res.success) {
            ElMessage({
              type: 'success',
              message: '删除成功'
            });
            // 获取选中任务的任务记录列表（）
            createResult.value = null;
            // selectedMedicalRecord(currentlySelectedSoundRecord.value)
            getLtyAsrAsrResultList(currentlySelectedSoundRecord.value);
          } else {
            ElMessage({
              type: 'error',
              message: res.error || '删除失败'
            });
          }
        }).catch(err => {
          ElMessage({
            type: 'error',
            message: err || '删除失败'
          });
        });
      }).catch(() => {});
    };

    // 修改录音文件患者名称
    const editPatientNameHandle = (item, index) => {
      medicalRecordList.value.forEach((listItem, listIndex) => {
        if (listIndex == index) {
          listItem.isEditPatientName = true;
        }
      });
      let times = setInterval(() => {
        if (editPatientNameInputRef.value) {
          clearInterval(times);
          editPatientNameInputRef.value[0].focus();
        }
      }, 100);
    };

    // 修改录音文件患者名称输入框失去焦点
    const editPatientNameBlur = (item, index) => {
      if (editPatientNameInputValue.value) {
        let params = {
          id: item.id,
          userId: userId.value,
          token: token.value,
          name: editPatientNameInputValue.value
        };
        ltyAsrAsrUpdateInfo(params).then(res => {
          medicalRecordList.value[index].isEditPatientName = false;
          if (res.success) {
            ElMessage.success('修改成功');
            GetltyAsrAsrList();
          } else {
            ElMessage.error(res.error || '修改失败');
          }
        }).catch(err => {
          ElMessage.error(err || '修改失败');
        });
      } else {
        medicalRecordList.value[index].isEditPatientName = false;
      }
    };

    // 修改录音文件患者名称输入框监听回车事件
    const editPatientNameEnter = (item, index) => {
      if (editPatientNameInputValue.value) {
        let params = {
          id: item.id,
          userId: userId.value,
          token: token.value,
          name: editPatientNameInputValue.value
        };
        ltyAsrAsrUpdateInfo(params).then(res => {
          medicalRecordList.value[index].isEditPatientName = false;
          if (res.success) {
            ElMessage.success('修改成功');
            GetltyAsrAsrList();
          } else {
            ElMessage.error(res.error || '修改失败');
          }
        }).catch(err => {
          ElMessage.error(err || '修改失败');
        });
      } else {
        medicalRecordList.value[index].isEditPatientName = false;
      }
    };

    // 修改录音文件患者病因
    const editDiseaseNameHandle = (item, index) => {
      medicalRecordList.value.forEach((listItem, listIndex) => {
        if (listIndex == index) {
          listItem.isEditDiseaseName = true;
        }
      });
      let times = setInterval(() => {
        if (editDiseaseNameInputRef.value) {
          clearInterval(times);
          editDiseaseNameInputRef.value[0].focus();
        }
      }, 100);
    };

    // 修改录音文件患者病因输入框失去焦点
    const editDiseaseNameBlur = (item, index) => {
      if (editDiseaseNameInputValue.value) {
        let params = {
          id: item.id,
          userId: userId.value,
          token: token.value,
          title: editDiseaseNameInputValue.value
        };
        ltyAsrAsrUpdateInfo(params).then(res => {
          medicalRecordList.value[index].isEditDiseaseName = false;
          if (res.success) {
            ElMessage.success('修改成功');
            GetltyAsrAsrList();
          } else {
            ElMessage.error(res.error || '修改失败');
          }
        }).catch(err => {
          ElMessage.error(err || '修改失败');
        });
      } else {
        medicalRecordList.value[index].isEditDiseaseName = false;
      }
    };

    // 修改录音文件患者病因输入框监听回车事件
    const editDiseaseNameEnter = (item, index) => {
      if (editDiseaseNameInputValue.value) {
        let params = {
          id: item.id,
          userId: userId.value,
          token: token.value,
          title: editDiseaseNameInputValue.value
        };
        ltyAsrAsrUpdateInfo(params).then(res => {
          medicalRecordList.value[index].isEditDiseaseName = false;
          if (res.success) {
            ElMessage.success('修改成功');
            GetltyAsrAsrList();
          } else {
            ElMessage.error(res.error || '修改失败');
          }
        }).catch(err => {
          ElMessage.error(err || '修改失败');
        });
      } else {
        medicalRecordList.value[index].isEditDiseaseName = false;
      }
    };
    const uploadRef = ref(null);
    const actionUrl = ref('');

    // 去登录
    const goLogin = () => {
      router.push({
        path: '/login'
      });
    };
    const uploadChange = async files => {
      if (!userId.value || !token.value) {
        router.push({
          path: '/login'
        });
        return;
      }
      if (files.status === 'ready') {
        uploadfileLoading.value = true;
        const file = files.raw;
        const fileName = file.name;
        const fileType = fileName.split('.').pop() || '';
        const url = URL.createObjectURL(file);
        const audioElement = new Audio(url);
        audioElement.addEventListener('loadedmetadata', () => {
          const duration = Math.floor(audioElement.duration);
          const size = duration * 1000;
          const formData = new FormData();
          formData.append('userId', userId.value);
          formData.append('token', token.value);
          formData.append('title', diseaseName.value || '未知疾病');
          formData.append('name', patientName.value || '不愿意透露姓名的患者');
          formData.append('size', size);
          formData.append('fileType', fileType);
          formData.append('file', file);
          ltyAsrUploadCreate(formData).then(res => {
            GetltyAsrAsrList();
            diseaseName.value = '';
            uploadfileLoading.value = false;
          }).catch(error => {
            ElMessage.error('上传创建失败');
            uploadfileLoading.value = false;
          });
        });
      }
    };
    const beforeUpload = file => {
      uploadfileLoading.value = true;
    };
    const uploadCreateInfo = ref(null); // 创建完成任务后云端给的oss taskId等信息
    const uploadSuccess = (file, files) => {
      // ElMessage.success('上传成功')
      // let params = {
      //   taskId: uploadCreateInfo.value.taskId,
      //   filekey: uploadCreateInfo.value.key,
      //   userId: userId.value,
      //   token: token.value
      // }
      // ltyAsruploadAf(params).then((res) => {
      //   GetltyAsrAsrList()
      // })
    };
    const uploadError = () => {
      ElMessage.error('上传失败');
    };

    // 查看全部
    const viewAllHandle = value => {
      isShowDrawer.value = true;
      drawerContent.value = value;
    };

    // 复制内容
    const copyTextHandle = async value => {
      try {
        // await navigator.clipboard.writeText(value)
        await toClipboard(value);
        ElMessage({
          message: '文本已复制到剪贴板',
          type: 'success'
        });
      } catch {
        ElMessage.error('复制到剪贴板失败');
      }
    };

    // 复制全部
    const copyAllContent = () => {
      if (!medicalRecordContent.value || !medicalRecordContent.value.length) {
        ElMessage({
          showClose: true,
          message: '录音暂无记录先新增一个试试吧~',
          type: 'warning'
        });
        return;
      }
      const allContent = medicalRecordContent.value.filter(contentItem => contentItem.textValue).map(contentItem => `${contentItem.title}\n${contentItem.textValue}`).join('\n\n');
      copyTextHandle(allContent);
    };

    //  获取语音列表
    const GetltyAsrAsrList = () => {
      let params = {
        userId: userId.value,
        token: token.value
      };
      ltyAsrAsrList(params).then(res => {
        if (res.data) {
          const {
            records,
            pages,
            size,
            total
          } = res.data;
          pageNumber.value = pages;
          pageSize.value = size;
          pageTotal.value = total;
          medicalRecordList.value = records;
          if (createResult.value) {
            records.filter((item, index) => {
              if (item.id == createResult.value.asrId && !item.isActive) {
                // 主动触发选中病历
                selectedMedicalRecord(item, index);
              }
            });
          }
          // else if (currentlySelectedSoundRecord.value) {
          //   records.filter((item, index) => {
          //     if (item.id == currentlySelectedSoundRecord.value.id) {
          //       // 主动触发选中病历
          //       selectedMedicalRecord(item, index)
          //     }
          //   })
          // }

          let hasActiveStatus = records.some(item => item.taskStatus === 0 || item.taskStatus === 1 || item.taskStatus === 2);
          // let hasActiveStatus = records.some(
          //   (item) => item.taskStatus === 1 || item.taskStatus === 2
          // )
          if (!hasActiveStatus) {
            isLoopCallInterface.value = false;
          } else {
            isLoopCallInterface.value = true;
            setTimeout(() => {
              GetltyAsrAsrList();
            }, 5000);
          }
        }
      });
    };

    // 点击选择任务记录
    const changeSelect = changeIndex => {
      selectOptions.value.filter((item, index) => {
        if (item.id == changeIndex) {
          createResult.value = {
            asrId: item.asrId,
            chatKey: item.chatKey
          };
          // 获取模板数据
          getLtyAsrAsrResult(item.id);
        }
      });
    };

    // 获取选中任务的任务记录列表
    const getLtyAsrAsrResultList = item => {
      console.log('获取选中任务的任务记录列表', item);
      console.log('createResult.value', createResult.value);
      let params = {
        userId: userId.value,
        token: token.value,
        asrId: item.id
      };
      ltyAsrAsrResultList(params).then(res => {
        if (res.data && res.data.length) {
          // 有 ai聊天界面通过router传回的参数
          if (createResult.value && createResult.value.chatKey) {
            res.data.filter((item, index) => {
              selectOptions.value = res.data;
              if (item.chatKey == createResult.value.chatKey) {
                selectValue.value = item.id;
              } else {
                selectValue.value = res.data[0].id;
              }
              // 获取模板数据
              getLtyAsrAsrResult(item.id);
            });
          } else {
            selectOptions.value = res.data;
            selectValue.value = res.data[0].id;
            createResult.value = {
              asrId: res.data.asrId,
              chatKey: res.data.chatKey
            };
            // 获取模板数据
            getLtyAsrAsrResult(res.data[0].id);
          }
        } else {
          selectOptions.value = null;
          selectValue.value = null;
        }
      });
    };

    // 根据任务id获取模板数据
    const getLtyAsrAsrResult = id => {
      console.log('根据任务id获取模板数据', medicalRecordList);
      medicalRecordContent.value = [];
      let params = {
        userId: userId.value,
        token: token.value,
        id
      };
      ltyAsrAsrResult(params).then(res => {
        if (res.data && res.data.result) {
          let resultData = JSON.parse(res.data.result);
          medicalRecordList.value.filter((item, index) => {
            for (const resultDataKey in resultData) {
              let childData = resultData[resultDataKey];
              let objData = {};
              if (resultDataKey == 'visitSummary') {
                objData.title = '问诊摘要 Visit Summary';
              } else if (resultDataKey == 'subjective') {
                objData.title = '主观资料 Subjective';
              } else if (resultDataKey == 'objective') {
                objData.title = '客观检查 Objective';
              } else if (resultDataKey == 'assessmentAndPlan') {
                objData.title = '评价和处置计划 Assessment & Plan';
              }
              // objData.title = resultDataKey 动态title
              objData.valueKey = resultDataKey;
              objData.textValue = '';
              if (typeof childData == 'object') {
                let childTitle = '';
                for (const childKey in childData) {
                  childTitle += childKey;
                  // 孙子
                  let grandsonData = childData[childKey];
                  if (typeof grandsonData == 'object') {
                    for (const grandsonKey in grandsonData) {
                      // 曾孙
                      let greatGrandsonData = grandsonData[grandsonKey];
                      if (typeof greatGrandsonData == 'object') {
                        for (const greatGrandsonKey in greatGrandsonData) {
                          let greatGreatGrandsonData = greatGrandsonData[greatGrandsonKey];
                          objData.textValue += greatGrandsonKey + '：';
                          objData.textValue += greatGreatGrandsonData + '\n\n';
                        }
                      } else {
                        objData.textValue += grandsonKey + '：';
                        objData.textValue += greatGrandsonData + '\n\n';
                      }
                    }
                  } else {
                    objData.textValue += childKey + '：';
                    objData.textValue += grandsonData + '\n\n';
                  }
                }
                // objData.title = childTitle + ' ' + objData.title 动态title
              } else {
                objData.textValue = childData;
              }
              medicalRecordContent.value.push(objData);
            }
          });
        }
      });
    };
    onMounted(() => {
      userId.value = localStorage.getItem('userId');
      token.value = localStorage.getItem('token');
      if (userId.value && token.value) {
        GetltyAsrAsrList();
      } else {
        router.push({
          path: '/login'
        });
      }
      if (route.query.createResult) {
        createResult.value = JSON.parse(route.query.createResult);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "label"
      }, "患者名称：", -1)), _createVNode(_component_el_input, {
        class: "disease-name-input",
        modelValue: patientName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => patientName.value = $event),
        placeholder: "请输入患者名称",
        clearable: ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "label"
      }, "疾病名称：", -1)), _createVNode(_component_el_input, {
        class: "disease-name-input",
        modelValue: diseaseName.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => diseaseName.value = $event),
        placeholder: "请输入疾病名称",
        clearable: ""
      }, null, 8, ["modelValue"])]), userId.value && token.value ? (_openBlock(), _createBlock(_component_el_upload, {
        key: 0,
        ref_key: "uploadRef",
        ref: uploadRef,
        class: "upload-demo",
        action: actionUrl.value,
        "auto-upload": false,
        onChange: uploadChange,
        "before-upload": beforeUpload,
        "on-success": uploadSuccess,
        "on-error": uploadError,
        headers: {
          'Content-type': 'application/octet-stream'
        },
        method: "put",
        accept: "audio/*"
      }, {
        trigger: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", _hoisted_7, _cache[15] || (_cache[15] = [_createTextVNode("上传录音")]))), [[_directive_loading, uploadfileLoading.value]])]),
        _: 1
      }, 8, ["action"])) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "upload-recording-btn",
        onClick: goLogin
      }, "上传录音"))]), _createElementVNode("div", _hoisted_8, [_cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "title"
      }, "全部病历", -1)), _createVNode(_component_el_scrollbar, {
        height: "1300px"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(medicalRecordList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "medical-record-item",
            key: index,
            style: _normalizeStyle([item.isActive ? {
              background: '#f1f1f1'
            } : {}]),
            onClick: $event => selectedMedicalRecord(item, index)
          }, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, {
            size: "20",
            color: "#666666",
            onClick: _withModifiers($event => deleteVoiceHandle(item, index), ["stop"])
          }, {
            default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
            _: 2
          }, 1032, ["onClick"])]), _createElementVNode("div", _hoisted_11, [item.isEditPatientName ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_input, {
            ref_for: true,
            ref_key: "editPatientNameInputRef",
            ref: editPatientNameInputRef,
            modelValue: editPatientNameInputValue.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => editPatientNameInputValue.value = $event),
            placeholder: "请输入患者名称",
            autofocus: true,
            clearable: "",
            onBlur: $event => editPatientNameBlur(item, index),
            onKeyup: _withKeys($event => editPatientNameEnter(item, index), ["enter"])
          }, null, 8, ["modelValue", "onBlur", "onKeyup"])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1), _createVNode(_component_el_icon, {
            class: "edit-patient-name-icon",
            size: "20",
            color: "#666666",
            onClick: _withModifiers($event => editPatientNameHandle(item, index), ["stop"])
          }, {
            default: _withCtx(() => [_createVNode(_unref(Edit))]),
            _: 2
          }, 1032, ["onClick"])])), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(_unref(dayjs)(item.createTime).format('YYYY-MM-DD')), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(dayjs)(item.createTime).format('HH:mm:ss')), 1)]), item.isEditDiseaseName ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_input, {
            ref_for: true,
            ref_key: "editDiseaseNameInputRef",
            ref: editDiseaseNameInputRef,
            modelValue: editDiseaseNameInputValue.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => editDiseaseNameInputValue.value = $event),
            placeholder: "请输入患者病因",
            autofocus: true,
            clearable: "",
            onBlur: $event => editDiseaseNameBlur(item, index),
            onKeyup: _withKeys($event => editDiseaseNameEnter(item, index), ["enter"])
          }, null, 8, ["modelValue", "onBlur", "onKeyup"])])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1), _createVNode(_component_el_icon, {
            class: "edit-disease-name-icon",
            size: "20",
            color: "#666666",
            onClick: _withModifiers($event => editDiseaseNameHandle(item, index), ["stop"])
          }, {
            default: _withCtx(() => [_createVNode(_unref(Edit))]),
            _: 2
          }, 1032, ["onClick"])]))]), _createElementVNode("div", _hoisted_21, [item.taskStatus == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, "等待上传")) : _createCommentVNode("", true), item.taskStatus == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_23, "上传完成")) : _createCommentVNode("", true), item.taskStatus == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_24, "解析中")) : _createCommentVNode("", true), item.taskStatus == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_25, "声音识别完成")) : _createCommentVNode("", true), item.taskStatus == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_26, "报告生成完成")) : _createCommentVNode("", true), item.taskStatus == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_27, "失败")) : _createCommentVNode("", true)])], 12, _hoisted_9);
        }), 128))]),
        _: 1
      })])]), currentlySelectedSoundRecord.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(currentlySelectedSoundRecord.value.name), 1), selectOptions.value && selectOptions.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_select, {
        modelValue: selectValue.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectValue.value = $event),
        class: "m-2",
        placeholder: "Select",
        size: "small",
        onChange: changeSelect
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.title,
            value: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_35, [_createVNode(_component_el_icon, {
              class: "edit-patient-name-icon",
              size: "20",
              color: "#666666",
              onClick: _withModifiers($event => deleteTaskRecord(item), ["stop"])
            }, {
              default: _withCtx(() => [_createVNode(_unref(Close))]),
              _: 2
            }, 1032, ["onClick"])])])]),
            _: 2
          }, 1032, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: gtpRecordHandle
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("GTP记录")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: addResultsHandle
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("新增结果")])),
        _: 1
      })]), _createVNode(_component_el_button, {
        class: "copy-all-btn",
        type: "primary",
        onClick: copyAllContent
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("复制全部")])),
        _: 1
      })])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(medicalRecordList.value, (recordListItem, recordListIndex) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "patient-information-list",
          key: recordListIndex
        }, [recordText.value ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "title"
        }, "录音文件解析结果", -1)), _createElementVNode("div", _hoisted_40, [_createVNode(_component_el_input, {
          modelValue: recordText.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => recordText.value = $event),
          autosize: {
            minRows: 4,
            maxRows: 12
          },
          type: "textarea",
          placeholder: "Please input"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[6] || (_cache[6] = $event => viewAllHandle(recordText.value))
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("查看全部")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_43, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = $event => copyTextHandle(recordText.value))
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("复制")])),
          _: 1
        })])])])) : _createCommentVNode("", true), medicalRecordContent.value && medicalRecordContent.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(medicalRecordContent.value, (contentItem, contentIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: contentIndex,
            class: "patient-information-item visit-summary"
          }, [_createElementVNode("div", _hoisted_44, _toDisplayString(contentItem.title), 1), _createElementVNode("div", _hoisted_45, [_createVNode(_component_el_input, {
            modelValue: contentItem.textValue,
            "onUpdate:modelValue": $event => contentItem.textValue = $event,
            autosize: {
              minRows: 4,
              maxRows: 200
            },
            type: "textarea",
            placeholder: "Please input"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_46, [_cache[24] || (_cache[24] = _createElementVNode("div", {
            class: "left"
          }, null, -1)), _createElementVNode("div", _hoisted_47, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => copyTextHandle(contentItem.textValue)
          }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("复制")])),
            _: 2
          }, 1032, ["onClick"])])])]);
        }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_cache[26] || (_cache[26] = _createTextVNode(" 没有任务记录哦~新建一个试试吧~ ")), _createElementVNode("div", _hoisted_50, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: addResultsHandle
        }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("新增结果")])),
          _: 1
        })])])]))])), [[_vShow, recordListItem.isActive]]);
      }), 128))])) : _createCommentVNode("", true)]), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => dialogVisible.value = $event),
        title: "选择平台和翻译结果",
        width: "500"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: generateHandle
        }, {
          default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode(" 去生成 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_cache[31] || (_cache[31] = _createElementVNode("h3", null, "AI翻译结果列表", -1)), _createElementVNode("div", _hoisted_51, [_createVNode(_component_el_radio_group, {
          modelValue: asrRecordId.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => asrRecordId.value = $event),
          onChange: changeRadio
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiTranslateList.value, listItem => {
            return _openBlock(), _createElementBlock("div", {
              class: "ai-translate-item",
              key: listItem.id
            }, [_createVNode(_component_el_radio, {
              value: listItem.id
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_53, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItem.result, (item, index) => {
                return _openBlock(), _createElementBlock("p", {
                  key: index
                }, _toDisplayString(item), 1);
              }), 128))])]),
              _: 2
            }, 1032, ["value"])]);
          }), 128))])]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_54, [_cache[28] || (_cache[28] = _createElementVNode("h3", null, "AI平台选择", -1)), _createVNode(_component_el_radio_group, {
          modelValue: chatPlatformId.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => chatPlatformId.value = $event)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_55, [_createVNode(_component_el_radio, {
            value: 0,
            size: "large"
          }, {
            default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("阿里-通义千问")])),
            _: 1
          })])]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_drawer, {
        modelValue: isShowDrawer.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => isShowDrawer.value = $event),
        title: "录音文件解析结果",
        direction: "rtl",
        size: "70%"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_57, _toDisplayString(drawerContent.value), 1)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};